"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChooseTailoredPagesButton = exports.ChooseDocUploaderButton = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./Buttons.css"));
var Page_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/UploadButton/Page.svg"));
var Lines_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/UploadButton/Lines.svg"));
var Lines_hover_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/UploadButton/Lines-hover.svg"));
var Cloud1_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/UploadButton/Cloud1.svg"));
var Cloud2_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/UploadButton/Cloud2.svg"));
var Lines_svg_2 = __importDefault(require("@ClientAssets/Images/docUploader/TailoredPagesButton/Lines.svg"));
var Lines_hover_svg_2 = __importDefault(require("@ClientAssets/Images/docUploader/TailoredPagesButton/Lines-hover.svg"));
var Rectangle_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/TailoredPagesButton/Rectangle.svg"));
var Rec2_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/TailoredPagesButton/Rec2.svg"));
var Rec3_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/TailoredPagesButton/Rec3.svg"));
var Star1_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/TailoredPagesButton/Star1.svg"));
var Star2_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/TailoredPagesButton/Star2.svg"));
var ChooseDocUploaderButton = function (_a) {
    var onStart = _a.onStart, wide = _a.wide;
    var _b = __read((0, react_1.useState)(false), 2), hovering = _b[0], setIsHovering = _b[1];
    return (react_1.default.createElement(ButtonCardWithGradient, { onHover: function () {
            setIsHovering(true);
        }, onBlur: function () {
            setIsHovering(false);
        }, onStart: onStart, wide: wide },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(DocUploadAnimatedIcon, { hovering: hovering }),
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", align: "center", strong: true }, "Upload your Doc"))));
};
exports.ChooseDocUploaderButton = ChooseDocUploaderButton;
var ChooseTailoredPagesButton = function (_a) {
    var onStart = _a.onStart, wide = _a.wide;
    var _b = __read((0, react_1.useState)(false), 2), hovering = _b[0], setIsHovering = _b[1];
    return (react_1.default.createElement(ButtonCardWithGradient, { onHover: function () {
            setIsHovering(true);
        }, onBlur: function () {
            setIsHovering(false);
        }, onStart: onStart, wide: wide },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TailoredPagesAnimatedIcon, { hovering: hovering }),
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", align: "center", strong: true }, "Start with tailored pages"))));
};
exports.ChooseTailoredPagesButton = ChooseTailoredPagesButton;
var DocUploadAnimatedIcon = function (_a) {
    var hovering = _a.hovering;
    return (react_1.default.createElement("div", { className: styles.svgContainer },
        react_1.default.createElement(kaleidoscope_1.SVG, { src: Cloud2_svg_1.default, className: styles.uploadSvgCloudLeft({ hovering: hovering }) }),
        react_1.default.createElement(kaleidoscope_1.SVG, { src: Page_svg_1.default, className: styles.uploadSvgPage }),
        react_1.default.createElement("div", { className: styles.uploadSvgLinesContainer },
            react_1.default.createElement(kaleidoscope_1.SVG, { src: Lines_svg_1.default, className: styles.uploadSvgLines }),
            react_1.default.createElement(kaleidoscope_1.SVG, { src: Lines_hover_svg_1.default, className: styles.uploadSvgLinesHover({ hovering: hovering }) })),
        react_1.default.createElement(kaleidoscope_1.SVG, { src: Cloud1_svg_1.default, className: styles.uploadSvgCloudRight({ hovering: hovering }) })));
};
var TailoredPagesAnimatedIcon = function (_a) {
    var hovering = _a.hovering;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.svgContainer },
            react_1.default.createElement(kaleidoscope_1.SVG, { src: Rec2_svg_1.default, className: styles.tailoredSvgHover2({ hovering: hovering }) }),
            react_1.default.createElement(kaleidoscope_1.SVG, { src: Rec3_svg_1.default, className: styles.tailoredSvgHover3({ hovering: hovering }) }),
            react_1.default.createElement(kaleidoscope_1.SVG, { src: Rectangle_svg_1.default, className: styles.uploadSvgPage }),
            react_1.default.createElement("div", { className: styles.tailoredSvgInnerContainer },
                react_1.default.createElement("div", { className: styles.uploadSvgLinesContainer },
                    react_1.default.createElement(kaleidoscope_1.SVG, { src: Lines_svg_2.default, className: styles.uploadSvgLines }),
                    react_1.default.createElement(kaleidoscope_1.SVG, { src: Lines_hover_svg_2.default, className: styles.uploadSvgLinesHover({ hovering: hovering }) })),
                react_1.default.createElement("div", { className: styles.tailoredSvgSquareContainer },
                    react_1.default.createElement("div", { className: styles.tailoredSvgSquare }),
                    react_1.default.createElement("div", { className: styles.tailoredSvgSquareHover({ hovering: hovering }) })))),
        react_1.default.createElement(kaleidoscope_1.SVG, { src: Star1_svg_1.default, className: styles.tailoredSvgStar1({ hovering: hovering }) }),
        react_1.default.createElement(kaleidoscope_1.SVG, { src: Star2_svg_1.default, className: styles.tailoredSvgStar2({ hovering: hovering }) })));
};
var ButtonCardWithGradient = function (_a) {
    var onStart = _a.onStart, wide = _a.wide, children = _a.children, onHover = _a.onHover, onBlur = _a.onBlur;
    return (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement(kaleidoscope_1.ButtonCard, { onClick: function () {
                onStart();
            }, onMouseEnter: onHover, onMouseLeave: onBlur, className: styles.card({ wide: wide }) },
            react_1.default.createElement(kaleidoscope_1.Stack, { paddingTop: "xxxl", paddingLeft: "xxxl", paddingRight: "xxxl", paddingBottom: "l", gap: "xl", align: "center" }, children))));
};
